import React from "react";
import PropTypes from "prop-types";
import { Graphics } from "./components/Graphics";
import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";
import Move from "./img/move.svg";
import { MoveMenu } from "./components/MoveMenu";
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

// Icons
import IconInfo from '@learningblocks/protocol-constants/lib/Icons/info-solid';
import "./style.scss";

import { Graphics as Solution } from "../Solution/components/Graphics"
import { SolutionContents } from "../Solution/components/SolutionContents";

class SolutionElement extends React.Component {

  componentDidMount() {
    window.setTimeout(() => {
      this.movemenu.style.bottom =
        "calc(100% + " + this.label.offsetHeight + "px)";
    }, 2000);
  }

  getLabel = (solution) => {

    const { labelReactionTubes } = this.props
    const { renamable, solutionAlias, fullName } = this.props.interactionProps.solutions[solution.id-1]

    if (!labelReactionTubes && renamable) {
      return <ReactMarkdown rehypePlugins={[rehypeRaw]} components={{p: 'span'}}>{solutionAlias.replace("\\_", "_")}</ReactMarkdown>;
    }
    return <ReactMarkdown rehypePlugins={[rehypeRaw]} components={{p: 'span'}}>{(typeof fullName !== "undefined")?fullName.replace("\\_", "_"):""}</ReactMarkdown>;
  }

  showSolutionContents = (solutionId) => {
    this.props.setShowSolutionContents({
      id: solutionId,
      showSolutionContents: !this.props.interactionProps.solutions[solutionId - 1].showSolutionContents
    });
  };

  showControls = (solutionId) => {
    this.props.hideAllControls();
    this.props.setSolutionControlVisibility({
      id: solutionId,
      controlsVisible: true,
    });
  };

  solutionSelected = (solutionId) => {
    if (!this.props.controlsVisible) {
      this.showControls(solutionId);
    }
    this.props.setSolutionHeld({
      id: solutionId,
      held: true,
    });
  };

  solutionUnselected = (solutionId) => {
    this.props.setSolutionHeld({
      id: solutionId,
      held: false,
    });
  };

  showMoveMenu = e => {
    this.props.setMoveMenu({
      type: this.props.solution.type,
      connect: this.props.solution.id
    });
    this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
  };

  render(){
    return (
      <ul
        key={this.props.solution.id}
        style={{
          zIndex: this.props.interactionProps.solutions[this.props.solution.id - 1].controlsVisible ? 99 : null
        }}
      >
        <li
          draggable
          onKeyDown={(e) => {
            if (e.keyCode === 13 || e.keyCode === 32) this.solutionSelected(this.props.solution.id);
          }}
          onMouseDown={()=>this.solutionSelected(this.props.solution.id)}
          onMouseUp={()=>this.solutionUnselected(this.props.solution.id)}
          onDragStart={(e)=>{
            this.props.setSolutionHeld({
              id: this.props.solution.id,
              held: true,
            })
            this.props.setHeldObject({
              id: this.props.solution.id,
              type: 'Solution',
              htmlObj: e.target,
            })
          }}
          onDragEnd={(e)=>{
            this.props.setSolutionHeld({
              id: this.props.solution.id,
              held: false,
            })
          }}
          id={'Solution_'+this.props.solution.id} tabIndex={0}
          className={'Solution draggable dropTarget'}
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)"}}>
          <div>
            <div
              className="label"
              aria-hidden="true"
              ref={(label) => {
                this.label = label;
              }}
            >
            <p> {this.getLabel(this.props.solution)}</p>
            <div
              className="solution-contents-menu"
              ref={(solutioncontents) => {
                this.solutioncontents = solutioncontents;
              }}
            >
              <button
                tabIndex={0}
                className={"solution-contents-button" + ((this.props.interactionProps.solutions[this.props.solution.id - 1].showSolutionContents)?" selected":"")}
                onClick={this.showSolutionContents.bind(this, this.props.solution.id)}
                aria-label="Solution contents. Select to view the contents of the tube."
              >
                <div style={{transform: 'rotate(180deg)'}}>
                  <IconInfo style={{color: (this.props.interactionProps.solutions[this.props.solution.id - 1].showSolutionContents)?colors.navy1:'white', height: null, display: 'block'}}/>
                </div>
              </button>
            </div>
          </div>
        </div>
        <Solution id={this.props.solution.id} />
        <div
          className="move-menu"
          ref={(movemenu) => {
            this.movemenu = movemenu;
          }}
          style={{ display: (this.props.interactionProps.solutions[this.props.solution.id - 1].controlsVisible ? null : "none") }}
        >
          <button
            tabIndex={0}
            className="move-button"
            onClick={this.showMoveMenu}
            aria-label="Move menu. Select to view the available positions."
          >
            <img src={Move} alt="Move menu icon." />
          </button>
          <MoveMenu type={this.props.solution.type} connect={this.props.solution.id} />
        </div>
        <div
          //style={{ display: (!this.props.interactionProps.solutions[this.props.solution.id - 1].controlsVisible) ? 'block' : "none" }}
        >
          <SolutionContents type={this.props.solution.type} connect={this.props.solution.id} />
        </div>
      </li>
      </ul>
    )
  }
}

export class IceBucket extends React.Component {
  componentWillMount() {
    this.props.createIceBucket({
      props: this.props.defaultProps,
    });
  }

  getIceBucketSolutions = () => {
    let solutions = this.props.solutions.map((solution, index)=>{
      if(solution.id !== null){
        return(<SolutionElement
            //{...this.props}
            setMoveMenu={this.props.setMoveMenu}
            showMoveMenu={this.props.showMoveMenu}
            interactionProps={this.props.interactionProps}
            setSolutionHeld={this.props.setSolutionHeld}
            setHeldObject={this.props.setHeldObject}
            setShowSolutionContents={this.props.setShowSolutionContents}
            hideAllControls={this.props.hideAllControls}
            setSolutionControlVisibility={this.props.setSolutionControlVisibility}
            solution={solution}
          />)
      } else {
        return(
          <li>
            <div style={{width: "29px", height: "101px"}}></div>
          </li>
        )
      }
    })
    return (
      <div className="IceBucketTubes">
        <ul>
        {solutions}
        </ul>
      </div>
    );
  }

  render() {
    return (
      <ul>
          {(this.props.solutions)?this.getIceBucketSolutions():null}
          <li style={{pointerEvents: "none" }}
              aria-label="Ice Bucket"
              id={"IceBucket_" + this.props.id} tabIndex={0}
              className="dropTarget IceBucket">
              <p aria-hidden="true" className="label">Ice Bucket</p>
              <Graphics id={this.props.id}/>
          </li>
      </ul>
    );
  }
}

IceBucket.propTypes = {
  createIceBucket: PropTypes.func,
};

IceBucket.defaultProps = {};
